import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import Cookies from "js-cookie";
import { loadStripe } from "@stripe/stripe-js";
import "./subscriptionPage.css";
import { SubscriptionContext } from "../../reducers/SubscriptionContext";

//console.log("Stripe Public Key New:", process.env.REACT_APP_STRIPE_PUBLIC_KEY);


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const SubscriptionPage = () => {
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [loading, setLoading] = useState(false);
    const [subscriptionStatus, setSubscriptionStatus] = useState("inactive"); // Track subscription status
    const history = useHistory();
    const { refreshSubscription } = useContext(SubscriptionContext);

    const planDetails = {
        MONTHLY: { name: "1 Month Plan", amount: 2.99 },
        QUARTERLY: { name: "3 Month Plan", amount: 5.99 },
        HALFYEARLY: { name: "6 Month Plan", amount: 9.99 },
    };

    // useEffect(() => {
    //     // Fetch subscription status (optional, if you have an API for this)
    //     fetchSubscriptionStatus();
    // }, []);

    // const fetchSubscriptionStatus = async () => {
    //     try {
    //         const user = await Auth.currentAuthenticatedUser();
    //         const session = await Auth.currentSession();
    //         const jwt = session.getIdToken().getJwtToken();
    //         const response = await fetch("https://api.quizwizard.net/quiz/getSubscription", {
    //             headers: { Authorization: jwt },
    //         });
    //         const data = await response.json();
    //         console.log("Subscription status:", data);
    //         setSubscriptionStatus(data.status || "inactive");
    //     } catch (error) {
    //         console.error("Error fetching status:", error);
    //     }
    // };

    const handleStripePayment = async () => {
        if (!selectedPlan) {
            alert("Please select a plan!");
            return;
        }

        try {
            setLoading(true);
            const user = await Auth.currentAuthenticatedUser();
            const session = await Auth.currentSession();
            const jwt = session.getIdToken().getJwtToken();
            const username = user.username.includes("Google_")
                ? user.attributes.email
                : user.username;



            const response = await fetch("https://api.quizwizard.net/quiz/stripePriceId", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: jwt,
                },
                body: JSON.stringify({
                    plan_type: selectedPlan,
                    username,
                }),
            });

            const data = await response.json();
            console.log("Stripe response:", data);
            if (!data.sessionId) throw new Error("Failed to create Stripe session");

            const stripe = await stripePromise;
            await stripe.redirectToCheckout({ sessionId: data.sessionId });

        } catch (error) {
            console.error("Stripe error:", error);
            alert("Stripe payment failed, please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleCancelSubscription = async () => {
        if (window.confirm("Are you sure you want to cancel your subscription?")) {
            try {
                const user = await Auth.currentAuthenticatedUser();
                const session = await Auth.currentSession();
                const jwt = session.getIdToken().getJwtToken();
                const username = user.username.includes("Google_")
                    ? user.attributes.email
                    : user.username;

                const response = await fetch("https://api.quizwizard.net/quiz/cancel-subscription", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: jwt,
                    },
                    body: JSON.stringify({ username }),
                });

                const data = await response.json();
                if (response.ok) {
                    alert("Subscription cancelled successfully!");
                    setSubscriptionStatus("cancelled");
                    refreshSubscription(); // Refresh subscription context
                    history.push("/subscription"); // Redirect to subscription page
                } else {
                    alert(data.error || "Failed to cancel subscription");
                }
            } catch (error) {
                alert("An error occurred while cancelling the subscription");
            }
        }
    };

    return (
        <div className="plan-wrapper">
            <h1 className="plan-heading">Choose Your Plan</h1>
            <p className="plan-subtitle">Upgrade to unlock unlimited access</p>

            <div className="plan-flex">
                {["MONTHLY", "QUARTERLY", "HALFYEARLY"].map((planType) => (
                    <div
                        key={planType}
                        className={`plan-card ${selectedPlan === planType ? "selected" : ""}`}
                        onClick={() => setSelectedPlan(planType)}
                    >
                        {planType === "QUARTERLY" && (
                            <div className="ribbon">
                                <span>Most Popular</span>
                            </div>
                        )}
                        <h2>{planDetails[planType].name}</h2>
                        <p className="price">${planDetails[planType].amount}</p>
                    </div>
                ))}
            </div>


            <div className="plan-actions">
                <button
                    className="pay-btn"
                    disabled={!selectedPlan || loading}
                    onClick={handleStripePayment}
                >
                    {loading ? "Processing..." : "Proceed to Payment"}
                </button>
                {subscriptionStatus === "active" && (
                    <button className="cancel-btn" onClick={handleCancelSubscription}>
                        Cancel Plan
                    </button>
                )}
            </div>
        </div>


    );
};

export default SubscriptionPage;